/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface TotalReward
 */
export interface TotalReward {
  /**
   *
   * @type {number}
   * @memberof TotalReward
   */
  farmed?: number
  /**
   *
   * @type {number}
   * @memberof TotalReward
   */
  staked?: number
  /**
   *
   * @type {number}
   * @memberof TotalReward
   */
  holderBonuses?: number
  /**
   *
   * @type {number}
   * @memberof TotalReward
   */
  cashback?: number
  /**
   *
   * @type {number}
   * @memberof TotalReward
   */
  referralRewards?: number
  /**
   *
   * @type {number}
   * @memberof TotalReward
   */
  total?: number
}

export function TotalRewardFromJSON(json: any): TotalReward {
  return TotalRewardFromJSONTyped(json, false)
}

export function TotalRewardFromJSONTyped(json: any, ignoreDiscriminator: boolean): TotalReward {
  if (json === undefined || json === null) {
    return json
  }
  return {
    farmed: !exists(json, 'farmed') ? undefined : json['farmed'],
    staked: !exists(json, 'staked') ? undefined : json['staked'],
    holderBonuses: !exists(json, 'holderBonuses') ? undefined : json['holderBonuses'],
    cashback: !exists(json, 'cashback') ? undefined : json['cashback'],
    referralRewards: !exists(json, 'referralRewards') ? undefined : json['referralRewards'],
    total: !exists(json, 'total') ? undefined : json['total'],
  }
}

export function TotalRewardToJSON(value?: TotalReward | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    farmed: value.farmed,
    staked: value.staked,
    holderBonuses: value.holderBonuses,
    cashback: value.cashback,
    referralRewards: value.referralRewards,
    total: value.total,
  }
}
